package net.sergeych.lyng

import kotlin.String

internal object BuildKonfig {
  public val bcprovider: String = "codingfeline"

  public val version: String = "1.5.11-SNAPSHOT"
}
